export default {
  SAMPLE_NUMBER: 'sampleNumber',
  LOT: 'lot',
  ACTIVE_MODULE_ID: 'activeModuleId',
  SAMPLE_DATE_TIME: 'sampleDateTime',
  H2: 'h2',
  CH4: 'ch4',
  C2H6: 'c2h6',
  C2H4: 'c2h4',
  C2H2: 'c2h2',
  CO: 'co',
  CO2: 'co2',
  O2: 'o2',
  N2: 'n2',
  LIMIT_DEFAULT_ANALYTICS: 'defaultAnalyticalDetectionLimit',
  ACCURACY_FACTOR: 'accuracyFactor',
  DEFAULT_ANALYTICS_H2: 'analyticalDetectionLimitH2',
  DEFAULT_ANALYTICS_CH4: 'analyticalDetectionLimitCH4',
  DEFAULT_ANALYTICS_C2H6: 'analyticalDetectionLimitC2H6',
  DEFAULT_ANALYTICS_C2H4: 'analyticalDetectionLimitC2H4',
  DEFAULT_ANALYTICS_C2H2: 'analyticalDetectionLimitC2H2',
  DEFAULT_ANALYTICS_CO: 'analyticalDetectionLimitCO',
  DEFAULT_ANALYTICS_CO2: 'analyticalDetectionLimitCO2',
  DEFAULT_ANALYTICS_O2: 'analyticalDetectionLimitO2',
  DEFAULT_ANALYTICS_N2: 'analyticalDetectionLimitN2',
  SAMPLE_TYPE: 'sampleType',
  DATE_ANALYSIS_HOUR: 'dateAnalysisHour',
  SAMPLE_TEMPERATURE: 'sampleTemperature',
  RELATIVE_AIR_HUMIDITY: 'relativeAirHumidity',
  ROOM_TEMPERATURE: 'roomTemperature',
  SAMPLE_LOCATION: 'sampleLocation',
  OBSERVATION: 'observation',
};
